module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "toc",
    attrs: {
      "id": "toc"
    }
  }, [_c('p', {
    staticClass: "chapterTitle1"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Contents")])]), _vm._v(" "), _c('p', {
    staticClass: "paraNoIndent"
  }, [_c('a', {
    attrs: {
      "href": "#/06a_Fouldeeds_introduction"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Introduction ")])])]), _vm._v(" "), _c('p', {
    staticClass: "paraNoIndent"
  }, [_c('a', {
    attrs: {
      "href": "#/07_Fouldeeds_ack"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Acknowledgements")])])]), _vm._v(" "), _c('table', {
    staticClass: "table1"
  }, [_c('tbody', [_c('tr', {
    attrs: {
      "valign": "top"
    }
  }, [_c('td', [_c('a', {
    attrs: {
      "href": "#/08_Fouldeeds_ch01"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Chapter 1")])])]), _vm._v(" "), _c('td'), _vm._v(" "), _c('td', [_c('a', {
    attrs: {
      "href": "#/08_Fouldeeds_ch01"
    }
  }, [_vm._v("Foul Deeds and Murder through the Ages, 1236–1984")])])]), _vm._v(" "), _c('tr', {
    attrs: {
      "valign": "top"
    }
  }, [_c('td', [_c('span', {
    attrs: {
      "href": "#/09_Fouldeeds_ch02",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Chapter 2")])])]), _vm._v(" "), _c('td'), _vm._v(" "), _c('td', [_c('span', {
    attrs: {
      "href": "#/09_Fouldeeds_ch02",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Gunpowder, Treason and Plot, 1605")])])]), _vm._v(" "), _c('tr', {
    attrs: {
      "valign": "top"
    }
  }, [_c('td', [_c('span', {
    attrs: {
      "href": "#/10_Fouldeeds_ch03",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Chapter 3")])])]), _vm._v(" "), _c('td'), _vm._v(" "), _c('td', [_c('span', {
    attrs: {
      "href": "#/10_Fouldeeds_ch03",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Execution of Charles I, Whitehall, 1649")])])]), _vm._v(" "), _c('tr', {
    attrs: {
      "valign": "top"
    }
  }, [_c('td', [_c('span', {
    attrs: {
      "href": "#/11_Fouldeeds_ch04",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Chapter 4")])])]), _vm._v(" "), _c('td'), _vm._v(" "), _c('td', [_c('span', {
    attrs: {
      "href": "#/11_Fouldeeds_ch04",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Claude Duval, the Dashing Highwayman, 1670")])])]), _vm._v(" "), _c('tr', {
    attrs: {
      "valign": "top"
    }
  }, [_c('td', [_c('span', {
    attrs: {
      "href": "#/12_Fouldeeds_ch05",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Chapter 5")])])]), _vm._v(" "), _c('td'), _vm._v(" "), _c('td', [_c('span', {
    attrs: {
      "href": "#/12_Fouldeeds_ch05",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Burning of Catherine Hayes, 1726")])])]), _vm._v(" "), _c('tr', {
    attrs: {
      "valign": "top"
    }
  }, [_c('td', [_c('span', {
    attrs: {
      "href": "#/13_Fouldeeds_ch06",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Chapter 6")])])]), _vm._v(" "), _c('td'), _vm._v(" "), _c('td', [_c('span', {
    attrs: {
      "href": "#/13_Fouldeeds_ch06",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Murdered by a Poet, 1727")])])]), _vm._v(" "), _c('tr', {
    attrs: {
      "valign": "top"
    }
  }, [_c('td', [_c('span', {
    attrs: {
      "href": "#/14_Fouldeeds_ch07",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Chapter 7")])])]), _vm._v(" "), _c('td'), _vm._v(" "), _c('td', [_c('span', {
    attrs: {
      "href": "#/14_Fouldeeds_ch07",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Killed in a Tiff over a Wig, 1735")])])]), _vm._v(" "), _c('tr', {
    attrs: {
      "valign": "top"
    }
  }, [_c('td', [_c('span', {
    attrs: {
      "href": "#/15_Fouldeeds_ch08",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Chapter 8")])])]), _vm._v(" "), _c('td'), _vm._v(" "), _c('td', [_c('span', {
    attrs: {
      "href": "#/15_Fouldeeds_ch08",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Shot by an Amorous Clergyman, 1779")])])]), _vm._v(" "), _c('tr', {
    attrs: {
      "valign": "top"
    }
  }, [_c('td', [_c('span', {
    attrs: {
      "href": "#/16_Fouldeeds_ch09",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Chapter 9")])])]), _vm._v(" "), _c('td'), _vm._v(" "), _c('td', [_c('span', {
    attrs: {
      "href": "#/16_Fouldeeds_ch09",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Assassination of the Prime Minister, 1812")])])]), _vm._v(" "), _c('tr', {
    attrs: {
      "valign": "top"
    }
  }, [_c('td', [_c('span', {
    attrs: {
      "href": "#/17_Fouldeeds_ch10",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Chapter 10")])])]), _vm._v(" "), _c('td'), _vm._v(" "), _c('td', [_c('span', {
    attrs: {
      "href": "#/17_Fouldeeds_ch10",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Cato Street Conspiracy, 1820")])])]), _vm._v(" "), _c('tr', {
    attrs: {
      "valign": "top"
    }
  }, [_c('td', [_c('span', {
    attrs: {
      "href": "#/18_Fouldeeds_ch11",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Chapter 11")])])]), _vm._v(" "), _c('td'), _vm._v(" "), _c('td', [_c('span', {
    attrs: {
      "href": "#/18_Fouldeeds_ch11",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Murder at the Adelphi, 1897")])])]), _vm._v(" "), _c('tr', {
    attrs: {
      "valign": "top"
    }
  }, [_c('td', [_c('span', {
    attrs: {
      "href": "#/19_Fouldeeds_ch12",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Chapter 12")])])]), _vm._v(" "), _c('td'), _vm._v(" "), _c('td', [_c('span', {
    attrs: {
      "href": "#/19_Fouldeeds_ch12",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Strange Disappearance of Victor Grayson, 1920")])])]), _vm._v(" "), _c('tr', {
    attrs: {
      "valign": "top"
    }
  }, [_c('td', [_c('span', {
    attrs: {
      "href": "#/20_Fouldeeds_ch13",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Chapter 13")])])]), _vm._v(" "), _c('td'), _vm._v(" "), _c('td', [_c('span', {
    attrs: {
      "href": "#/20_Fouldeeds_ch13",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Murder at the "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Savoy Hotel")]), _vm._v(", 1923")])])]), _vm._v(" "), _c('tr', {
    attrs: {
      "valign": "top"
    }
  }, [_c('td', [_c('span', {
    attrs: {
      "href": "#/21_Fouldeeds_ch14",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Chapter 14")])])]), _vm._v(" "), _c('td'), _vm._v(" "), _c('td', [_c('span', {
    attrs: {
      "href": "#/21_Fouldeeds_ch14",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Charing Cross Trunk Murder, 1927")])])])])]), _vm._v(" "), _c('p', {
    staticClass: "paraNoIndent"
  }, [_c('span', {
    attrs: {
      "href": "#/22_Fouldeeds_Sources",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Sources and Further Reading ")])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-05237546","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/06_Fouldeeds_contents.vue
// module id = 69
// module chunks = 0